import styled, { keyframes, css } from 'styled-components'
import { getDashColor } from '../../styles'

interface LoaderProps {
  small?: boolean
}
export const LoaderContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  background-color: transparent;
`
export const LoaderNoMarginContainer = styled.div`
  width: 64px;
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  background-color: transparent;
`

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

export const Spinner = styled(styled.div``) <LoaderProps>`
  width: 64px;
  height: 64px;
  border: 8px solid;
  border-color: ${getDashColor('SECONDARY_BLUE_06', 'SECONDARY_COLOR')} transparent ${getDashColor('SECONDARY_BLUE_06', 'SECONDARY_COLOR')} transparent;
  border-radius: 50%;
  animation: ${rotate} 1.2s linear infinite;
  ${(props) =>
    props.small &&
    css`
      width: 28px;
      height: 28px;
      border: 4px solid;
      border-radius: 50%;
      animation: ${rotate} 1.2s linear infinite;
      border-color: ${getDashColor('SECONDARY_BLUE_06', 'SECONDARY_COLOR')} transparent ${getDashColor('SECONDARY_BLUE_06', 'SECONDARY_COLOR')} transparent;
    `}
`

export const FullScreen = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(255, 255, 255);
  z-index: 9999;
`
